var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgReportingCountRightIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.88886V15.1111C0 15.4707 0.21924 15.7947 0.5556 15.9323C0.89184 16.0699 1.27896 15.9939 1.53636 15.7397L8.73636 8.6286C8.9052 8.46184 9 8.23571 9 7.99998C9 7.76424 8.9052 7.53811 8.73636 7.37147L1.53636 0.260373C1.27896 0.00615104 0.89184 -0.0698902 0.5556 0.0676856C0.21924 0.205273 0 0.529397 0 0.88891V7.11109V8.88886Z",
    fill: "#9BA5AE"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReportingCountRightIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ReportingCountRightIcon.01d03430.svg";
export { ForwardRef as ReactComponent };